module.exports = __webpack_public_path__ + "img/asus-laptop.bb9dc370.jpg";